import { HoatDongChung as IHoatDongChung } from '@/services/MauDanhGia';
import { getHoatDongDanhGia } from '@/services/MauDanhGia/maudanhgia';
import { useState } from 'react';

export default () => {
  const [danhSach, setDanhSach] = useState<IHoatDongChung.Record[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [record, setRecord] = useState<IHoatDongChung.Record>({} as any);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [cond, setCondition] = useState<any>({});
  const [filterInfo, setFilterInfo] = useState<any>({});
  const [edit, setEdit] = useState<boolean>(false);
  const [visibleForm, setVisibleForm] = useState<boolean>(false);
  const getHoatDongDanhGiaModel = async () => {
    setLoading(true);
    const response = await getHoatDongDanhGia({ page, limit, cond: {...cond} });
    setDanhSach(response?.data?.data?.result ?? []);
    setTotal(response?.data?.data?.total);
    setLoading(false);
  }
  return {
    record,
    setRecord,
    danhSach,
    loading,
    setLoading,
    getHoatDongDanhGiaModel,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
    cond,
    setCondition,
    filterInfo,
    setFilterInfo,
    setVisibleForm,
    edit,
    setEdit,
    visibleForm,
  };
};
